<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">

    <g app-blank-goban
       [width]="width()"
       [height]="height()"
       (clickCallBack)="onClick($event)"/>

    <g id="pieces">
        @for (line of board; track $index; let y = $index) {
            <g>
                @for (spaceContent of line; track $index; let x = $index) {
                    <g>
                        @if (spaceContent.isPlayer()) {
                            <circle id="piece-{{ x }}-{{ y }}"
                                    [attr.cx]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * x)"
                                    [attr.cy]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * y)"
                                    [attr.r]="SPACE_SIZE * 0.44"
                                    [ngClass]="getSpaceClass(x, y)"
                                    class="base"/>
                        }
                    </g>
                }
            </g>
        }
    </g>
    @if (droppedCoord.isPresent()) {
        <circle id="dropped"
                (click)="onClick(droppedCoord.get())"
                [attr.cx]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * droppedCoord.get().x)"
                [attr.cy]="(SPACE_SIZE * 0.5) + (SPACE_SIZE * droppedCoord.get().y)"
                [attr.r]="SPACE_SIZE * 0.44"
                [ngClass]="getSpaceClass(droppedCoord.get().x, droppedCoord.get().y)"
                class="base moved-stroke"/>
    }
</svg>
